import Vue from 'vue'
import App from './App.vue'
import i18n from '@/locale'
import router from './router'
import ElementUi from 'element-ui'
import './assets/scss/element-variables.scss'
import './utils'
import store from './store'
import VueClipboard from 'vue-clipboard2'

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
if (isMobile) {
	import('@fortawesome/fontawesome-free/css/all.min.css')
	import('amfe-flexible')
}

Vue.config.productionTip = false

Vue.use(ElementUi);
Vue.use(VueClipboard);

// PC 版账号页面对应的手机版路由映射
const mobilePageMap = {
	'/Home/User/Index': '/m/Account',
	'/Home/User/MotifyPassword': '/m/Account/Password',
	'/Home/User/MotifyAliasName': '/m/Account/Nickname',
	'/Home/Guild/Index': '/m/Guild/List',
	'/Home/Guild/Detail': '/m/Guild/Detail',
	'/Home/Guild/Create': '/m/Guild/Create',
	'/Home/Guild/Apply': '/m/Guild/Apply',
};

// 手机版路由映射到PC版（反向映射）
const pcPageMap = {};
Object.keys(mobilePageMap).forEach(function(pc) {
	pcPageMap[mobilePageMap[pc]] = pc;
});

// 使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
	var bLogined = false;

	if (null != store.state.token && store.state.expireTime > ((new Date().getTime()))) {
		bLogined = true;
	}

	// 手机端访问强制跳转到手机版
	if (isMobile && !to.path.startsWith("/m")) {
		if (mobilePageMap[to.path]) {
			next(mobilePageMap[to.path]);
		} else {
			next("/m");
		}
		return;
	}

	// PC端访问手机版页面，跳转回PC版
	if (!isMobile && to.path.startsWith("/m") && process.env.NODE_ENV === 'production') {
		const mapped = pcPageMap[to.path];
		if (mapped) {
			next(mapped);
		} else {
			// 生产环境 PC 端访问/m，跳回首页
			next('/');
		}
		return;
	}

	if (false == bLogined && to.path !== '/' && to.path !== '/Index' &&
		to.name !== 'MemberDonate' && to.name !== 'Mobile' && to.name !== 'MobileDownload' &&
		to.name !== 'MobileRegister' && to.name !== 'MobilePay' && to.name !== 'MobileDiscord' &&
		to.name !== 'MobileAccount' && to.name !== 'MobileChangePassword' &&
		to.name !== 'MobileChangeNickname' && to.name !== 'MobileChangeEmail' &&
		to.name !== 'MobileChangeGender' &&
			to.name !== 'MobileGuildList' && to.name !== 'MobileGuildDetail' &&
			to.name !== 'MobileGuildCreate' && to.name !== 'MobileGuildApply' &&
			to.name !== 'MobileForgotUsername' &&
			to.name !== 'MobileForgotPassword' &&
			to.name !== 'Error') {
		// 开发环境：PC端访问/m放行
		if (process.env.NODE_ENV !== 'production' && to.path.startsWith("/m")) {
			next();
			return;
		}

		var hadToken = store.state.token;
		store.commit("clear");

		if (hadToken) {
			store.state.ShowLoginPanel = true;
		}

		next('/');
	} else {
		next();
	}
});

new Vue({
	i18n,
	render: h => h(App),
	router,
	store
}).$mount('#app')
